import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FilterSelect from "../components/FilterSelect";
import ReactPlaceholder from 'react-placeholder';
import {TextBlock, RectShape} from 'react-placeholder/lib/placeholders';

import InfiniteScroll from 'react-infinite-scroller';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Media from 'react-media';

import Fido from '../utils/Fido';
import PaddedLayout from '../components/PaddedLayout.js';
import SearchForm from '../components/SearchForm.js';
import FullscreenMessage from '../components/FullscreenMessage';
import Constants from "../utils/Constants";
import CircularLoadingIndicator from "../components/CircularLoadingIndicator";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

import {
	withStyles,
	withWidth,
	Fab,
	Card,
	CardActionArea,
	CardContent,
	Paper,
	Grid,
	Typography,
	withTheme,
} from '@material-ui/core';

const styles = theme => ({
	locationGridContainer: {
		// The following style is taken from the class MuiTGrid-container
		// Also adding spacing={2} which comes from MuiGrid-spacing
		display: "flex",
		flexWrap: "wrap",
		boxSizing: "border-box",
		width: "100%",
		marginBottom: theme.spacing(4)
	},

	locationGridItem: {
		// The following styles are taken from the class MuiGrid-spacing > MuiGrid-item
		padding: theme.spacing(2)
	},

	title: {
		fontSize: "24px",
		fontWeight: "bold",
		marginTop: 0,
		lineHeight: "1.75em",
		fontFamily: "Merriweather",
		lineHeight: "32px",
	},

	map: {
		maxWidth: "100%",
		height: "auto",
		display: "block"
	},

	card: {
		maxWidth: 610,
		margin: "0 auto",
		borderRadius: 20,
	},

	cardAction: {
		maxWidth: 610,
		// border: "1px solid black",
	},

	cardContent: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2), 
	},

	subTitleText: {
		// padding: `0 ${theme.spacing(2)}px`,
		fontSize: 16,
		fontWeight: 400,
	},

	cardBodyText: {
		// padding: `0 ${theme.spacing(2)}px`,
		color: theme.palette.secondary.grey,
	},

	cardBodyGeoText: {
		padding: `16px 0px`,
		fontWeight: 700,
	},

	statusCell: {
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 6
		}
	},

	statusIcon: {
		width: "0.55rem !important",
		paddingRight: theme.spacing(1)
	},

	statusActive: {
		color: theme.palette.secondary.green
	},

	statusInactive: {
		color: theme.palette.text.secondary
	},

	fab: {
		zIndex: 1,
		color: theme.palette.common.white,
		borderRadius: 12,
		fontSize: 13,
		margin: 24,

		[theme.breakpoints.down('xs')]: {
			left: theme.spacing(2.5)
		}
	},

	fabExtendedIcon: {
		marginRight: theme.spacing(1)
	},

	fabLink: {
		textDecoration: "none"
	},

	paddedLayout: {
		// paddingBottom: theme.spacing(3)
	},

	statusFilter: {
		// marginTop: theme.spacing(2.5),
		// marginRight: theme.spacing(2)
		border: `1px solid ${theme.palette.primary.lightGrey}`,
		borderRadius: 12,
		// width: 164,
		// paddingRight: theme.spacing(2)
	},

	fullScreenClassName: {
		[theme.breakpoints.only('md')]: {
			paddingTop: `${theme.spacing(27.5)}px !important`
		},

		[theme.breakpoints.only('sm')]: {
			paddingTop: `${theme.spacing(26.375)}px !important`
		}
	},
	spaceAround: {
		padding: "16px 24px",
		border: `1px solid ${theme.palette.secondary.lightGrey}`,
		borderRadius: "12px",
		marginBottom: 38,
		marginTop: 12,
	},
});

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const itemPlaceHolder = (
	<div>
		<Paper style={{padding: 10, marginTop: 10, maxWidth: 610, margin: "0 auto"}}>
			<div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 16}}>
				<RectShape color={placeholderColor} style={{maxWidth: "100%", height: 250, display: "block"}} />
			</div>
			<div style={{display: "flex", marginTop: 25, flexDirection: "column"}}>
				<div style={{flex: 1}}>
					<TextBlock rows={2} color={placeholderColor} style={{width: "95%"}} />
				</div>
				<div style={{flex: 1, marginTop: 10}}>
					<TextBlock rows={2} color={placeholderColor} style={{width: "100%"}} />
				</div>
			</div>
		</Paper>
	</div>
);

class Locations extends Component {
	constructor(props) {
		super(props);

		this.defaultStatuses = [{id: "active", name: "Active"}];

		this.state = {
			hasMoreItems: true,
			isLoading: false,
			order: 'asc',
			orderBy: 'name',
			fullLocations: [],
			locations: null,
			fidoError: false,
			loadPage: 2,
			selectedLocation: null,
			searchActive: false,
			allLocations: false,
			filter: {
				selectedStatuses: [this.defaultStatuses[0].id]
			},
			statuses: Constants.LOCATION.STATUSES
		};

		this.searchHandler = this.searchHandler.bind(this);
		this.clearHandler = this.clearHandler.bind(this);
		this.loadItems = this.loadItems.bind(this);
		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleExclusions = this.handleExclusions.bind(this);
		this.filterLocationStatus = this.filterLocationStatus.bind(this);
		this.shouldReset = this.shouldReset.bind(this);

		this.fido = new Fido();
	}

	componentDidMount() {
		let {updateHeader, setFullScreenClassName, classes} = this.props;
		setFullScreenClassName(classes.fullScreenClassName);
		updateHeader({title: "locations", primary: true});
		this.setupFilters();
	}

	componentWillUnmount() {
		this.fido.dropIt();
		this.props.resetHeader();
	}

	componentDidUpdate(prevProps, prevState) {
		this.handleExclusions(this.props.history);

		// This allows the tabs to act properly when using the drawer nav
		if(prevProps.location.search !== this.props.location.search) {
			this.setupFilters();
		}

		// Edge case where the window is able to hold the entire first set of results without a scroll bar
		// This loads more pages until the area is scrollable.
		if ((document.body.clientHeight < window.innerHeight) && this.state.locations && this.state.locations.length > 0 && this.state.fullLocations.length > 0 && this.state.hasMoreItems && !this.state.isLoading) {
			let page = this.state.loadPage;
			this.loadItems(page);
			this.setState({loadPage: page + 1});
		}
	}

	shouldReset(prevProps) {
		if (this.props.location.search === "" && prevProps.location.search !== "") {
			return true;
		}

		return false;
	}

	fetchData(opts) {
		let {filter} = this.state,
			url = `/locations`;

		if (filter.selectedStatuses && filter.selectedStatuses.length) {
			url = `${url}?status=${filter.selectedStatuses.join(",")}`;
		}

		this.fido.fetch(url, opts)
			.then((data) => {
				if (data) {
					// Separate state to hold the full location set for use in search
					data.fullLocations = data.locations;
					this.setState(data);
				}
			})
			.catch(this.handleLocationsError);
	}

	loadItems(page) {
		// Check to make sure there is more to load
		if(this.state.hasMoreItems === true) {
			// Set a loading flag so we don't double-load
			this.setState({
				isLoading: true
			});

			// Edge case (above) causes the 'pageStart' prop to be incorrect
			if(this.state.loadPage > 2) {
				page = this.state.loadPage;
			}

			let {filter} = this.state,
				url = `/locations?page=${page}`;

			if (filter.selectedStatuses && filter.selectedStatuses.length) {
				url = `${url}&status=${filter.selectedStatuses.join(",")}`;
			}

			// Get the next page of data from the paginator
			this.fido.fetch(url)
				.then((data) => {
					if(data) {
						var locations = this.state.locations;
						data.locations.map((location) =>
							locations.push(location)
						);

						let update = {
							locations: locations,
							isLoading: false
						};
						if(this.state.loadPage > 2) {
							update.loadPage = page + 1;
						}
						if(!data.hasMoreItems) {
							update.hasMoreItems = false;
						}

						this.setState(update);
					}
				})
				.catch(error => this.props.showSnackbar(error.message));
		} else {
			this.setState({allLocations: true});
		}
	}

	searchHandler(formVals) {
		let {filter} = this.state;
		this.setState({searchActive: true, hasMoreItems: false});
		this.fido.fetch("/locations", {
			method: "POST",
			body: JSON.stringify({
				locations: this.state.fullLocations,
				search: formVals.search,
				allLocations: this.state.allLocations,
				status: Array.isArray(filter.selectedStatuses) ? filter.selectedStatuses : filter.selectedStatuses.split(",")
			})
		})
			.then(this.handleLocationsUpdate)
			.catch(this.handleLocationsError);
	}

	clearHandler() {
		this.setState({locations: this.state.fullLocations, searchActive: false});
	}

	handleLocationsUpdate = (data) => {
		if (data) {
			this.setState({locations: data});
		}
	}

	handleLocationsError = (error) => {
		this.setState({fidoError: true});
		this.props.showSnackbar(error.message);
	}

	handleRowClick(location) {
		this.setState({selectedLocation: location});
	}

	handleExclusions(history) {
		let removed;
		// defining here so don't need to pass in dependencies that are in scope in this func
		let updateRemovedParameter = function(removeIndex) {
			if(removeIndex > -1) {
				// update search param
				removed.splice(removeIndex, 1);
				let removedParams = "";
				if(removed.length) {
					removedParams = '?' + removed.join("&");
				}
				history.push({
					removed: removedParams
				});
			}
		};

		if("location" in history && history.location.removed) {
			removed = history.location.removed.slice(1).split('&');
			let excludeIndex = removed.findIndex(query => query.indexOf('exclude') > -1);
			if(excludeIndex > -1) {
				let excludedId = removed[excludeIndex].split('=')[1];
				this.filterLocation(excludedId);
				updateRemovedParameter(excludeIndex, removed);
			}
		}
	}

	filterLocation(locationId) {
		let locations = this.state.locations;
		if(locations) {
			/* eslint-disable eqeqeq */
			locations = locations.filter(location => location.id != locationId);
			/* eslint-enable eqeqeq */
			this.setState({locations: locations});
		}
	}

	getFiltersFromUrl() {
		return {
			status: Fido.getSearchParam("status", this.props.location.search)
		};
	}

	setupFilters() {
		this.setState({
			filter: {
				selectedStatuses: ["active"]
			}
		});
	}

	filterLocationStatus(obj) {
		this.setState({
			locations: null,
			allLocations: !this.state.hasMoreItems,
			statusFilterOpen: false,
			filter: {
				selectedStatuses: obj.status
			}
		}, () => {
			let {filter} = this.state,
				url = `/locations`;

			if (filter.selectedStatuses && filter.selectedStatuses.length) {
				url = `${url}?status=${Array.isArray(filter.selectedStatuses) ? filter.selectedStatuses.join(",") : filter.selectedStatuses}`;
			}

			this.fido.fetch(url)
				.then((data) => {
					if (data) {
						// Separate state to hold the full location set for use in search
						data.fullLocations = data.locations;
						this.setState(data);
					}
				})
				.catch(this.handleLocationsError);
		});
	}

	render() {
		let { locations, selectedLocation, statuses, hasMoreItems, isLoading, fidoError } = this.state;
		let { classes, theme, location } = this.props,
			fabClassName,
			fabClassNames = [classes.fab],
			firstLoaded = this.state.locations !== null;

		fabClassName = clsx(fabClassNames);

		if (selectedLocation) {
			return (
				// don't overwrite browser stack, push=true
				<Redirect push to={{
					pathname: `/settings/locations/${selectedLocation.id}`
				}}/>
			);
		} else {
			return (
				<AuthorizedUserContext.Consumer>
					{authenticatedUser => {
						return (
							<PaddedLayout
								noTopPad
								isLarge
								className={classes.spaceAround}>
								<Grid
									container
									alignItems="center"
									spacing={3}
									justifyContent="flex-start">
									<Grid item xs={2} md={3} lg={4} xl={3}>
										<Link to={`/settings/locations/add`} tabIndex={-1} className={classes.fabLink}>
											<Media query={{minWidth: theme.breakpoints.values.sm}}>
												{matches =>
													matches ? (
														<Fab
															variant="extended"
															color="primary"
															aria-label="Add Location"
															className={fabClassName}>
															<FontAwesomeIcon
																title="add"
																icon={["far", "plus"]}
																className={classes.fabExtendedIcon} /> Add Location
														</Fab>
													) : (
														<Fab
															color="primary"
															aria-label="Add Location"
															className={fabClassName}>
															<FontAwesomeIcon title="add" icon={["far", "plus"]} />
														</Fab>
													)
												}
											</Media>
										</Link>
									</Grid>
									<Grid item xs={2} md={3} lg={4} xl={2}>
												<FilterSelect
													includeSelectAll
													name="status"
													menuTitle="Status"
													selectAllTitle="All statuses"
													options={statuses}
													location={location}
													defaultSelections={this.defaultStatuses[0].id}
													className={classes.statusFilter}
													handleUpdate={this.filterLocationStatus} />
									</Grid>		
									<Grid item xs={9} md={6} lg={4} xl={7}>
										<SearchForm
											searchHandler={this.searchHandler}
											clearHandler={this.clearHandler} />
									</Grid>
									{/* <Grid item xs={10} md={9} lg={8} xl={9}>
										<Grid container justifyContent="space-between" spacing={2} alignItems="center">
											
										</Grid>
									</Grid> */}
								</Grid>
								{firstLoaded ? (
									locations && locations.length ? (
										<React.Fragment>
											<InfiniteScroll
												// Classes added on this mock that of a Grid container
												className={classes.locationGridContainer}
												initialLoad={false}
												pageStart={1}
												loader={null}
												loadMore={this.loadItems}
												hasMore={hasMoreItems && !isLoading}>
												{locations.map(n => {
													let hometown = n.use_profile_locations ? "On" : "Off",
														iconType = "fas",
														iconCls = n.active ? classes.statusActive : classes.statusInactive,
														textCls = n.active ? null : classes.statusInactive;

													return (
														<Grid className={classes.locationGridItem} key={n.id} item xs={12} lg={6} xl={4}>
															<Card className={classes.card}>
																<CardActionArea className={classes.cardAction} onClick={() => this.handleRowClick(n)}>
																	<img src={n.map} alt={n.name} className={classes.map} />
																	<CardContent className={classes.cardContent}>
																		<Typography variant="h2" noWrap className={`${classes.title} ${textCls}`}>
																			<FontAwesomeIcon
																				title="status indicator"
																				icon={[iconType, "circle"]}
																				className={`${classes.statusIcon} ${iconCls}`} />{n.name}
																		</Typography>
																		<Typography noWrap className={`${classes.subTitleText} ${textCls}`}>{n.address}, {n.city}, {n.state} {n.zip}</Typography>
																		{authenticatedUser.accountFeatures.includes(Constants.ACCOUNT.FEATURES.SOCIAL_MEDIA) &&
																		authenticatedUser.permissions.includes(Constants.USER.PERMISSIONS.DATA.SOCIAL_MEDIA) ?
																			<div>
																				<Typography className={`${classes.cardBodyGeoText} ${textCls}`}>Geofence Matching:</Typography>
																				<Typography className={`${classes.cardBodyText} ${textCls}`}>Author Profile Location: {hometown}</Typography>
																				<Typography className={`${classes.cardBodyText} ${textCls}`}>Geotagged Post Location: On</Typography>
																			</div> : null
																		}
																		<br />
																		<Typography className={`${classes.cardBodyText} ${textCls}`}>Team Members: {n.team_members}</Typography>
																	</CardContent>
																</CardActionArea>
															</Card>
														</Grid>
													);
												})}
											</InfiniteScroll>
											{isLoading ?
												<CircularLoadingIndicator /> : null
											}
										</React.Fragment>
									) : (
										<FullscreenMessage message="No Results" />
									)
								) : (
									<div className={classes.locationGridContainer}>
										<Grid className={classes.locationGridItem} item xs={12} lg={6} xl={4}>
											<ReactPlaceholder
												ready={false}
												customPlaceholder={itemPlaceHolder}
												showLoadingAnimation={!fidoError}>
												<span></span>
											</ReactPlaceholder>
										</Grid>
										<Grid className={classes.locationGridItem} item xs={12} lg={6} xl={4}>
											<ReactPlaceholder
												ready={false}
												customPlaceholder={itemPlaceHolder}
												showLoadingAnimation={!fidoError}>
												<span></span>
											</ReactPlaceholder>
										</Grid>
										<Grid className={classes.locationGridItem} item xs={12} lg={6} xl={4}>
											<ReactPlaceholder
												ready={false}
												customPlaceholder={itemPlaceHolder}
												showLoadingAnimation={!fidoError}>
												<span></span>
											</ReactPlaceholder>
										</Grid>
									</div>
								)}
							</PaddedLayout>
						);
					}}
				</AuthorizedUserContext.Consumer>
			);
		}
	}
}

Locations.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	width: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	snackbarOpen: PropTypes.bool,
	showSnackbar: PropTypes.func,
	resetHeader: PropTypes.func,
	updateHeader: PropTypes.func,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default withStyles(styles)(withWidth()(withTheme(Locations)));
